import * as React from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, SubmissionError } from 'redux-form';
import { LinkHelper } from '../../routes';
import { login } from '../../models/Auth';
import Button from '../../components/Button/Button';
const styles = require('./Login.less') as any;
/* import { debug } from '../../../utils';
 * const log = debug('lego:Login.tsx');*/
import { TextField } from '../../components/fields';

const validate = values => {
		const errors = {};
		const requiredFields = [ 'username', 'password' ];
		// const requiredFields = [ 'email', 'password' ];
		requiredFields.forEach(field => {
				if (!values[ field ]) errors[ field ] = 'Required';
		});
		/* if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
		 *		 errors['email'] = 'Invalid email address';
		 * }*/
		return errors;
}
import { handleSubmissionError } from '../utils'
import get from 'lodash/get';
@connect(null, { login })
@reduxForm({form: 'login', validate})
export default class Login extends React.Component<any,any> {
		render() {
				const { handleSubmit, pristine, submitting, error } = this.props

        return (
						<div id='RegisterPage'>
								<div className={styles.container}>
									<h1 className={styles.heading}>Sign-In</h1>
										<form onSubmit={handleSubmit(handleSubmissionError(this.props.login))}>
											<div style={{position: 'relative', zIndex: 1000}}>
                        Don't have an account? Go to the <LinkHelper to='register'>Registration Page</LinkHelper>
                      </div>

                      <div style={{display: 'flex', 'flexDirection': 'column', alignItems: 'center'}}>
												<Field name='username'
                               component={TextField} label='Username' placeholder='Username' autoCapitalize='none' autoFocus />
												<Field name='password'
                               component={TextField} type='password' label='Password' placeholder='Password' />
                        {error && <div><strong>{error}</strong></div>}

                        <div style={{textAlign: 'right'}}>
												  <Button type='submit' disabled={pristine || submitting}>Login</Button>
                        </div>
                      </div>
										</form>
								</div>
						</div>
				);
		}
}
//<div><Field name='email' component={TextField} label='Email Address' placeholder="you@youremail.com" /></div>



// WEBPACK FOOTER //
// ./src/app/containers/Login/Login.tsx